export default __webpack_public_path__ + "static/media/348.2e852e3b.png";